import React from "react";
import PageComponent from "../PageComponent";
import SearchSimilar from "./SearchSimilar";
import KnowledgeService from "../../../../services/KnowledgeService";
import CommonUtil from "../../../../utils/CommonUtil";
import PathUtil from "../../../../utils/PathUtil";
import { paths } from "../../../paths";
import { withKeycloak } from "@react-keycloak/web";

class SearchSimilarContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.state = {
      similarEntity: undefined,
      entity: undefined,
      isLoading: false
    };

    this.onePageInfo = {
      size: 1,
      number: 0
    };

    this.knowledgeService = new KnowledgeService(this.keycloak);
  }

  componentDidMount() {
    super.componentDidMount();
    this.checkAndLoadSimilar();
  }

  componentDidUpdate() {
    this.checkAndLoadSimilar();
  }

  checkAndLoadSimilar = () => {
    if (
      !this.state.isLoading &&
      !CommonUtil.jsonEquals(this.props.entity, this.state.entity)
    ) {
      this.setState(
        { entity: this.props.entity, isLoading: true },
        this.loadSimilarEntity
      );
    }
  };

  loadSimilarEntity = () => {
    this.knowledgeService.postSearchSimilar(
      this.state.entity,
      this.onePageInfo,
      undefined,
      this.onSimilarEntityLoad,
      this.messageHandler.handleError
    );
  };

  onSimilarEntityLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      const similarEntity = dataContent[0];
      this.setState({ similarEntity, isLoading: false });
    }
  };

  openInNewTab = () => {
    const itemPath = PathUtil.itemPath(
      paths.KNOWLEDGE_ITEM,
      this.state.similarEntity.id
    );
    window.open(itemPath, "_blank", "noopener");
  };

  render() {
    return (
      <SearchSimilar
        similarEntity={this.state.similarEntity}
        isLoading={this.state.isLoading}
        openInNewTab={this.openInNewTab}
        isInDialog={this.props.isInDialog}
      />
    );
  }
}

export default withKeycloak(SearchSimilarContainer);
